import { EmptyStateWithContainer } from 'ui/emptyState';
import { ProvisionedEmptyState } from 'ui/illustrations';

export const CustomPushDestinationsEmptyState = () => (
  <EmptyStateWithContainer
    Illustration={ProvisionedEmptyState}
    title="Ready to send some push messages?"
    subtitle={
      <span>
        Click <b>Add destination</b> to get started.
      </span>
    }
  />
);
